var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 17.5059L12.5 12.5059M2.5 8.33919C2.5 9.10524 2.65088 9.86378 2.94404 10.5715C3.23719 11.2792 3.66687 11.9223 4.20854 12.464C4.75022 13.0057 5.39328 13.4353 6.10101 13.7285C6.80875 14.0216 7.56729 14.1725 8.33333 14.1725C9.09938 14.1725 9.85792 14.0216 10.5657 13.7285C11.2734 13.4353 11.9164 13.0057 12.4581 12.464C12.9998 11.9223 13.4295 11.2792 13.7226 10.5715C14.0158 9.86378 14.1667 9.10524 14.1667 8.33919C14.1667 7.57315 14.0158 6.81461 13.7226 6.10687C13.4295 5.39914 12.9998 4.75608 12.4581 4.2144C11.9164 3.67273 11.2734 3.24305 10.5657 2.9499C9.85792 2.65674 9.09938 2.50586 8.33333 2.50586C7.56729 2.50586 6.80875 2.65674 6.10101 2.9499C5.39328 3.24305 4.75022 3.67273 4.20854 4.2144C3.66687 4.75608 3.23719 5.39914 2.94404 6.10687C2.65088 6.81461 2.5 7.57315 2.5 8.33919Z",
    stroke: "#99939F",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f80066e1a4ff437ab689332c81dcc548.svg";
export { ForwardRef as ReactComponent };